<template>
<div class="font-D-container font-Duration1" style="">
    
</div>
</template>

<script>

export default {
  name: "BaseMethodCardDuration"
}

</script>

<style scoped>

</style>